var impressum = "Mentions légales";
var privacy = "Confidentialité et mentions légales";
var recallInfo = "Informations de rappel";
var signOut = "Déconnexion";
var fr_ca = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { fr_ca as default, impressum, privacy, recallInfo, signOut };
